<!--
     <PDFViewerHeader
       
     />

     Accepted props:
      - currentPage
      - numPages
      - scale
      - increment
        
     
     Events:
      - updateScale
      - updateFit
      - goToPage
      - showPreview
      - close
-->
<template>
  <header class="pdf-header pdf-viewer__header box-shadow" style="background-color: #606f7b;">

    <!-- PREVIEW -->
    <div class="pdf-preview-toggle">
      <v-icon v-if="!is_mobile" @click="showPreview" large color="white">
        mdi-menu
      </v-icon>
    </div>

    <!-- ZOOM -->
    <div class="pdf-zoom">
        <v-icon @click.prevent.stop="zoomIn"  :disabled="isDisabled" color="white" large>
            mdi-magnify-plus
        </v-icon>
        <v-icon @click.prevent.stop="zoomOut"  :disabled="isDisabled" color="white" large>
            mdi-magnify-minus
        </v-icon>
        <v-icon @click.prevent.stop="fitWidth"  :disabled="isDisabled" color="white" large>
            mdi-fullscreen
        </v-icon>
        <v-icon v-if="!is_mobile" @click.prevent.stop="fitHeight"  :disabled="isDisabled" color="white" large>
            mdi-fullscreen-exit
        </v-icon>
    </div>

    <!-- PAGINATOR -->
    <div class="pdf-paginator">
        <input
          :value="page"
          @input="inputPage"
          :min="numPages > 0 ? '1' : '0'"
          :max="numPages"
          type="number"
          class="pdf-page-input"
        /> <span style="color:white;">/ {{ numPages }}</span>
    </div>

    <!-- CLOSE -->
    <div class="pdf-close">
      <v-icon @click="close" medium color="white">mdi-exit-to-app</v-icon>
    </div>
  </header>
</template>

<script>
export default {
  name: 'PDFViewerHeader',
  components: {
  },
  props: {
    is_mobile: {
      type: Boolean,
      default: false,
    },
    currentPage: {
      type: Number,
      default: 0
    },
    numPages: {
      type: Number,
      default: 0
    },
    scale: {
      default: 1
    },
    increment: {
      type: Number,
      default: 0.25
    },
  },
  
  data() {
    return {
      isDisabled: false,
      page: 0,
    };
  },

  computed: {
  },

  mounted(){
    this.page = this.numPages > 0 ? this.currentPage : 0;
  },

  methods: {
      close() {
        this.$emit('close');
      },
      showPreview() {
        this.$emit('showPreview');
      },
      updateScale(scale) {
        this.$emit('updateScale', scale);
      },
      inputPage(input) {
        if (this.currentPage > 0 && +input.target.value >0 && +input.target.value !== this.currentPage) {
          this.$emit('goToPage',+input.target.value);
        }
      },
      zoomIn() {
      this.updateScale(this.scale + this.increment);
      },

      zoomOut() {
        if (this.scale > this.increment * 2) {
          this.updateScale(this.scale - this.increment);
        }
      },
      
      fitWidth() {
        this.$emit('updateFit','width');
      },

      fitHeight() {
        this.$emit('updateFit','height');
      },
  },
  watch: {
    currentPage () {
      if (this.currentPage > 0 && this.currentPage <= this.numPages) {
        this.page = this.currentPage;
      }
    },
    numPages () {
      if (this.numPages > 0) {
        this.page = this.currentPage;
      }
    }
  },
      
  }
</script>
<style lang="scss">
@import "@/sass/pdf.scss";
</style>